import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NEW_FEATURE_MODAL_KEY = 'newFeatureModalShown_v1';

const NewFeatureModal: React.FC = () => {
	const [isVisible, setIsVisible] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const hasSeenModal = localStorage.getItem(NEW_FEATURE_MODAL_KEY);
		if (!hasSeenModal) {
			setIsVisible(true);
		}
	}, []);

	const handleClose = () => {
		localStorage.setItem(NEW_FEATURE_MODAL_KEY, 'true');
		setIsVisible(false);
	};

	const handleViewInstructions = () => {
		// Navigacija ka uputstvu ili otvaranje PDF-a
		navigate('/help/page?id=reportingMeasure');
		handleClose();
	};

	return (
		<Dialog
			open={isVisible}
			onClose={handleClose}
			maxWidth='md'
			fullWidth
			PaperProps={{
				sx: {
					borderRadius: 2,
				},
			}}
		>
			<DialogTitle sx={{ fontSize: '18px', fontWeight: 'bold', pb: 1 }}>Нови модул: Извештавање</DialogTitle>

			<DialogContent>
				<Box sx={{ lineHeight: 1.8, fontSize: '15px' }}>
					<Typography variant='body1' paragraph>
						<strong>Поштовани корисници,</strong>
					</Typography>

					<Typography variant='body1' paragraph>
						У апликацији је доступна нова функционалност — <strong>Извештавање</strong>, који омогућава детаљно праћење и анализу прописа и мера. Модул можете пронаћи у хедеру, док се у сајд бару
						налазе опције <strong>Извештавање о прописима</strong> и <strong>Извештавање о мерама</strong>.
					</Typography>

					<Typography variant='body1' paragraph>
						<strong>У оквиру модула доступне су следеће функционалности:</strong>
					</Typography>

					<Box sx={{ ml: 2.5 }}>
						<Typography variant='body1' paragraph>
							<strong>Аналитички преглед</strong> у горњем делу екрана:
						</Typography>
						<Box component='ul' sx={{ mt: -2, ml: 2.5 }}>
							<li>укупан број прописа</li>
							<li>реализовано у текућем кварталу</li>
							<li>пренето из претходног квартала</li>
							<li>нереализовано и преноси се у наредни квартал</li>
						</Box>

						<Typography variant='body1' paragraph sx={{ mt: 2 }}>
							📌 Поља за претрагу по називу прописа/мере и по институцији
						</Typography>
						<Typography variant='body1' paragraph>
							📌 Филтери: <strong>Планирани</strong> и <strong>Нереализовани</strong>
						</Typography>
						<Typography variant='body1' paragraph>
							📌 Табеле са називима мера и прописа, институцијама и роковима за реализацију
							<br />
							<em>(поља су информативна и нису директно едитабилна)</em>
						</Typography>

						<Typography variant='body1' paragraph>
							📌 <strong>Додатна поља која јесу едитабилна</strong> — за измену података довољно је да кликнете на одговарајуће поље; отвориће се popup у коме можете извршити ажурирање.
						</Typography>

						<Typography variant='body1' paragraph>
							📌 <strong>Поред наслова</strong> — на обе нове странице можете пронаћи упутство за коришћење нове функционалности.
						</Typography>
					</Box>

					<Typography variant='body1' sx={{ mt: 2.5, fontStyle: 'italic' }}>
						Хвала што користите нашу апликацију!
					</Typography>
				</Box>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={handleClose} variant='outlined'>
					Затвори
				</Button>
				{/* <Button
          onClick={handleViewInstructions}
          variant="contained"
          color="primary"
        >
          Погледај Упутство
        </Button> */}
			</DialogActions>
		</Dialog>
	);
};

export default NewFeatureModal;
